/*! @azure/msal-browser v2.15.0 2021-06-29 */
'use strict';

import { BrowserConfigurationAuthError } from '../error/BrowserConfigurationAuthError.js';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

var stubbedPublicClientApplication = {
  acquireTokenPopup: function acquireTokenPopup() {
    return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
  },
  acquireTokenRedirect: function acquireTokenRedirect() {
    return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
  },
  acquireTokenSilent: function acquireTokenSilent() {
    return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
  },
  getAllAccounts: function getAllAccounts() {
    return [];
  },
  getAccountByHomeId: function getAccountByHomeId() {
    return null;
  },
  getAccountByUsername: function getAccountByUsername() {
    return null;
  },
  getAccountByLocalId: function getAccountByLocalId() {
    return null;
  },
  handleRedirectPromise: function handleRedirectPromise() {
    return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
  },
  loginPopup: function loginPopup() {
    return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
  },
  loginRedirect: function loginRedirect() {
    return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
  },
  logout: function logout() {
    return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
  },
  logoutRedirect: function logoutRedirect() {
    return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
  },
  logoutPopup: function logoutPopup() {
    return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
  },
  ssoSilent: function ssoSilent() {
    return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
  },
  addEventCallback: function addEventCallback() {
    return null;
  },
  removeEventCallback: function removeEventCallback() {
    return;
  },
  getLogger: function getLogger() {
    throw BrowserConfigurationAuthError.createStubPcaInstanceCalledError();
  },
  setLogger: function setLogger() {
    return;
  },
  setActiveAccount: function setActiveAccount() {
    return;
  },
  getActiveAccount: function getActiveAccount() {
    return null;
  },
  initializeWrapperLibrary: function initializeWrapperLibrary() {
    return;
  },
  setNavigationClient: function setNavigationClient() {
    return;
  }
};
export { stubbedPublicClientApplication };